module.exports = __webpack_public_path__ + "img/icon_mail.ca7b0a0d.svg";